import { useState, useCallback } from "react";
import { toastTips } from "utils/tools";

/**
 *获取异步数据的hook
 * @export
 * @param {Function} fn 异步函数
 * @param {Array} deps 依赖项
 * @param {Object} initialState 初始状态
 * @param {Function}  btnCallback 按钮回调函数
 * @param {Boolean}  showToast 是否显示toast
 * @return {Array}
 */
export default function useAsyncFn(fn, deps, initialState, btnCallback, showToast = false, successMessage = "success") {
  const [dataState, setState] = useState(initialState);
  const callback = useCallback((...args) => {
    setState((preState) => ({ ...preState, isLoading: true, isFinished: false }));
    try {
      return fn(...args).then(
        (res) => {
          const { data } = res;
          const status = res.status;
          if (btnCallback !== undefined && typeof btnCallback === "function") {
            btnCallback(data, status);
          }
          if (showToast) {
            if (status === "Success") {
              toastTips(successMessage, "success");
            }
          }
          setState((preState) => ({ ...preState, isLoading: false, isError: false, data: data, active: false }));
          let timer = null;
          if (timer !== null) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            setState((preState) => {
              return { ...preState, active: false, isFinished: true };
            });
          }, 3000);
        },
        (err) => {
          console.log(err);
          // toastTips("error", "error");
          setState((preState) => ({ ...preState, isLoading: false, isError: true, active: false }));
          let timer = null;
          if (timer !== null) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            setState((preState) => {
              console.log(preState);
              return { ...preState, isFinished: true };
            });
          }, 2000);
        },
      ).catch(e =>console.log(e.message));
    } catch (error) {
      console.log(error);
      // toastTips("error", "error");
      setState((preState) => ({ ...preState, isLoading: false, isError: true }));
    }
  }, deps);
  return [dataState, callback];
  //callback 是一个包装了异步操作的函数。这个 callback 函数会在你调用它时执行传入的异步函数 fn，并根据该异步操作的结果更新状态（dataState）
}
